import {createContext, useEffect, useState} from "react";

export const ThemeContext = createContext()
export function ThemeProvider({children}) {

    const [Theme, setTheme] = useState('Light')


    useEffect(() => {
        document.body.setAttribute("data-theme", Theme);
    }, [Theme]);


    function changeTheme(theme) {
        if (theme==='Light')
            setTheme('Dark')
        else if (theme==='Dark')
            setTheme('Light')
       /* else if (theme==='Auto')
            setTheme('Light')*/

        // document.body.setAttribute("data-theme", Theme);
    }
    return (
        <ThemeContext.Provider value={{Theme,changeTheme}}>
            {children}
        </ThemeContext.Provider>
    )
}